"use client";

import { useState } from "react";
import { FaDollarSign } from "react-icons/fa";
import "./styles/AddressInput.css"; // Import your CSS styles
import { Icons } from "../assets/icons/Icons";

const AddressInput = ({
    type = "text",
    label,
    placeholder,
    value,
    onChange,
    icon,
    readOnly = false,
    onActionClick,
    actionText,
    currencySymbol,
    currencyCode,
}) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);

    // Determine which icon to use
    const getIcon = () => {
        if (icon) return icon;

        // Default icons based on type
        if (type === "amount") return <Icons.FaDollarSign />;
        if (type === "address") return <Icons.FaBox />;

        return null;
    };

    return (
        <div className="custom-input-container">
            {label && (
                <label
                    className="font-11 font-700 pt-2"
                    style={{ color: "#797373" }}
                >
                    {label}
                </label>
            )}

            <div className={`input-wrapper ${isFocused ? "focused" : ""}`}>
                <div className="input-icon">{getIcon()}</div>

                <div className="input-content">
                    {type === "amount" && value ? (
                        <div className="amount-display">
                            <span className="amount-value">{value}</span>
                            {currencyCode && (
                                <span className="currency-code">
                                    ({currencyCode})
                                </span>
                            )}
                        </div>
                    ) : (
                        <input
                            type={type === "amount" ? "number" : "text"}
                            placeholder={placeholder}
                            value={value}
                            onChange={onChange}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            readOnly={readOnly || type === "amount"}
                            className="custom-input"
                        />
                    )}
                </div>

                {actionText && (
                    <button className="action-button" onClick={onActionClick}>
                        {actionText}
                    </button>
                )}
            </div>
        </div>
    );
};

export default AddressInput;
